<section *ngIf="isCartSticky" class="scheduler-section cart-section"
  [ngClass]="isCartSticky === true ? 'cart-sticky' : 'cart-hide-header'">
  <div class="d-flex justify-content-center marginBottom">
    <div class="stickyStatus" *ngIf="!isCalendarViewOnly">
      <div *ngIf="schedulerStatus=='All units and doses have been scheduled'">
        <img src="assets/icons/confirmation-positive-green.png"/>
      </div>
      <div *ngIf="schedulerStatus=='Exceeds Total'" class="mt-3">
        <div class="text-center">Exceeds Total</div>
        <div class="text-center">Remove from calendar</div>
      </div>
      <div [ngClass]="{'unit-scheduled':schedulerStatus=='All units and doses have been scheduled'}" 
      *ngIf="schedulerStatus != 'Exceeds Total'">{{schedulerStatus}}
      </div>
    </div>
    <div class="scheduler sticky-scheduler" *ngIf="!isCalendarViewOnly">
      <div class="units-doses mt-2" *ngIf="(schedulerStatus=='Remaining to schedule' || schedulerStatus=='Exceeds Total')">
        <div>
          <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingUnits)}}</div>
          <div>units</div>
        </div>
        <span>|</span>
        <div>
          <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingDoses)}}</div>
          <div>Doses</div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center plpbutton-header ml-2 mt-3" *ngIf="!isCalendarViewOnly && stsProductsJoinedList?.length >0">
      <button type="button" class="btn-primary mr-2 btn-small-sts" [disabled]="!isCalendarUpdated || thresholdError" (click)="saveChanges()">
        Save changes
      </button>
      <button type="button" class="btn-secondary schdl-later btn-small-sts" [disabled]="!isCalendarUpdated" (click)="cancelChanges()">
        Cancel changes
      </button>
    </div>
  </div>
    <div class="col-lg-12 col-md-12 col-sm-12 frequencyItems align-frequency product-sticky" *ngIf="stsProductsJoinedList?.length >0">
      <div class="col-lg-11 col-md-12 col-sm-12 cart" > 
        <div class="eachItemFrequency product" *ngFor="let stsProdData of stsProductsJoinedList; let i = index">
          <span class="prod-no">{{stsProdData.materialNum}}</span> 
          <span class="frequencyItemHead">
            <a (click)="productDetails(stsProdData)" title="{{stsProdData?.name}}"  class="cart_title">
              <p class="prod-des" [innerHTML]="stsProdData?.variantProductDescription"></p>
            </a>
          </span>
          <div class="selectFreq">
            <ng-select bindLabel="name" bindValue="code"
              [multiple]="false" 
              [(ngModel)]="stsProdData.selectedFreq"
              name="{{'frequencyList'+stsProdData?.materialNum}}"
              placeholder="Select frequency"
              (change)="frequencyChange($event,stsProdData)"
              [disabled]="isCalendarViewOnly">
              <ng-option *ngFor="let freq of stsProdData.frequencyList"
              [value]="freq.code">{{freq.name}}</ng-option>
            </ng-select>
          </div>
          <span class="freqRemainScdle" *ngIf="stsProdData?.quantity > 0">Remaining to schedule</span> 
          <span class="freqRemainScdle" *ngIf="stsProdData?.quantity == 0 ">Scheduled</span>
          <span class="freqRemainScdle" *ngIf="stsProdData?.quantity < 0">Remove from calendar</span>
          <span class="freqUnits sched-freq" *ngIf="stsProdData?.quantity > 0">{{stsProdData?.quantity}} Units | {{stsProdData?.quantity * stsProdData?.quantityPerUnit}} Doses</span>
          <span class="freqUnits sched-freq success" *ngIf="stsProdData?.quantity == 0">{{stsProdData?.productQuantityValue}} Units | {{stsProdData?.productQuantityValue * stsProdData?.quantityPerUnit}} Doses</span>
          <span class="freqUnits sched-freq error" *ngIf="stsProdData?.quantity < 0">{{myMath.abs(stsProdData?.quantity)}} Units | {{myMath.abs(stsProdData?.quantity) * stsProdData?.quantityPerUnit}} Doses</span>
        </div>      
    </div>
    </div>
  <div class="non-sticky update-calendar sticky-calendar updateRow marginTop" *ngIf="updateFreqFlag">
    <div class="headTxt">Update the calendar with your frequency selections.</div>
    <button type="button" class="btn btn-primary updateCal" (click)="updateCalendar()">
     Update Calendar
    </button>
    <button type="button" class="btn btn-secondary cancelCal" (click)="cancelUpdateCalendar()">
      Cancel
    </button>
  </div>
</section>

<div class="container-fluid" id="main-Container">

  <div class="row">
  <section class="scheduler-section">
    <div class="row">
    <div class="col-md-5 col-lg-5 col-sm-12 scheduler-content">
      <div *ngIf="isCalendarViewOnly" class="lock-text" [innerHTML] = "lockMessage"></div>
      <div class="headline-text" [innerHTML] = "headerMessage" *ngIf="headerContent"></div>
      <ng-template #headerContentSample>
        <h3><strong>Set your own Shipping Schedule &nbsp;Optional</strong></h3>
      </ng-template>

      <div class="program-text" [innerHTML] = "programMessage" *ngIf="programContent"></div>
      <ng-template #programContentSample>
        <p>This is a&nbsp;Business configurable -&nbsp; RSD. It sets up messaging below.</p>
      </ng-template>
      <div class="quick-text" [innerHTML] = "quickMessage" *ngIf="quickContent"></div>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-12" *ngIf="!isCalendarViewOnly">
      <div class="scheduler">
        <div *ngIf="schedulerStatus=='All units and doses have been scheduled'">
          <img src="assets/icons/confirmation-positive-green.png"/>
        </div>
        <div *ngIf="schedulerStatus=='Exceeds Total'">
          <div class="text-center">Exceeds Total</div>
          <div class="text-center">Remove from calendar</div>
        </div>
        <div [ngClass]="{'unit-scheduled':schedulerStatus=='All units and doses have been scheduled'}" 
        *ngIf="schedulerStatus != 'Exceeds Total'">{{schedulerStatus}}
        </div>
        <div class="units-doses mt-2"
          *ngIf="(schedulerStatus=='Remaining to schedule' || schedulerStatus=='Exceeds Total')">
          <div>
            <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingUnits)}}</div>
            <div>units</div>
          </div>
          <span>|</span>
          <div>
            <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingDoses)}}</div>
            <div>Doses</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-12 locked-div" *ngIf="isCalendarViewOnly">

    </div>
    <div class="col-md-4 col-lg-4 col-sm-12" *ngIf="!isCalendarViewOnly && stsProductsJoinedList?.length >0">
      <section class="plpbutton2">
        <button type="button" class="btn-primary btn-small-sts" [disabled]="!isCalendarUpdated || thresholdError" (click)="saveChanges()">
          Save changes
        </button>
        <br />
        <button type="button" class="btn-secondary schdl-later btn-small-sts" [disabled]="!isCalendarUpdated" (click)="cancelChanges()">
         Cancel changes
        </button>
      </section>
    </div>
  </div>
  <div class="col-sm-12 col-md-12 no-xs visible-xs visible-sm" *ngIf="stsProductsJoinedList?.length >1">
    <strong>Not optimized for mobile devices.</strong> <br> 
      <span>We recommend viewing this page on larger screens for a better experience.
    </span>
  </div>
  </section>
  </div>

  <!--Shipping Frequency and products section -->
  <div class="row" *ngIf="stsProductsJoinedList?.length >0">
  <section class="scheduler-section cart-section">
    <div>
      <p>
        <img class="mr-2" src="assets/icons/{{baseSiteId}}/shipping.png" alt="" />Shipping Frequency
      </p>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 frequencyItems align-frequency">
      <div class="col-lg-11 col-md-12 col-sm-12 cart pl-4" > 
          <div class="eachItemFrequency product" *ngFor="let stsProdData of stsProductsJoinedList; let i = index">
            <div class="imgContainer">
              <img *ngIf="stsProdData?.thumbNailImg && stsProdData?.thumbNailImg!== ''" 
              src="{{baseUrl}}{{stsProdData?.thumbNailImg}}"
              title="{{stsProdData?.name}}" alt=""/>
              <img *ngIf="!stsProdData?.thumbNailImg || stsProdData?.thumbNailImg == ''" 
              src="../assets/img/missing_product_EN_300x300.jpg" 
              title="{{stsProdData?.name}}" alt=""/>
            </div>
            <span class="prod-no">{{stsProdData.materialNum}}</span> 
            <span class="frequencyItemHead">
              <a (click)="productDetails(stsProdData)" title="{{stsProdData?.name}}"  class="cart_title">
                <p class="prod-des" [innerHTML]="stsProdData?.variantProductDescription"></p>
              </a>
            </span>
            <div class="selectFreq">
              <ng-select bindLabel="name" bindValue="code"
              [multiple]="false" 
              [(ngModel)]="stsProdData.selectedFreq"
              name="{{'frequencyList'+stsProdData?.materialNum}}"
              placeholder="Select frequency"
              (change)="frequencyChange($event,stsProdData)"
              [disabled]="isCalendarViewOnly">
              <ng-option *ngFor="let freq of stsProdData.frequencyList"
              [value]="freq.code">{{freq.name}}</ng-option>
            </ng-select>
            </div>
            <!--below 2 will change based on user's action, then will apply conditions.
            currently as per new reservation case once user lands on the page
             quantity as remaining scheduled quantity (will change on user's action)
             productQuantityValue as original quantity (will not change)-->
            <span class="freqRemainScdle" *ngIf="stsProdData?.quantity > 0">Remaining to schedule</span> 
            <span class="freqRemainScdle" *ngIf="stsProdData?.quantity == 0 ">Scheduled</span>
            <span class="freqRemainScdle" *ngIf="stsProdData?.quantity < 0">Remove from calendar</span>
            <span class="freqUnits sched-freq" *ngIf="stsProdData?.quantity > 0">{{stsProdData?.quantity}} Units | {{stsProdData?.quantity * stsProdData?.quantityPerUnit}} Doses</span>
            <span class="freqUnits sched-freq success" *ngIf="stsProdData?.quantity == 0">{{stsProdData?.productQuantityValue}} Units | {{stsProdData?.productQuantityValue * stsProdData?.quantityPerUnit}} Doses</span>
            <span class="freqUnits sched-freq error" *ngIf="stsProdData?.quantity < 0">{{myMath.abs(stsProdData?.quantity)}} Units | {{myMath.abs(stsProdData?.quantity) * stsProdData?.quantityPerUnit}} Doses</span>
          </div>      
      </div>
    </div>
    <div class="non-sticky update-calendar sticky-calendar updateRow marginTop" *ngIf="updateFreqFlag">
      <div class="headTxt">Update the calendar with your frequency selections.</div>
      <button type="button" class="btn btn-primary updateCal" (click)="updateCalendar()">
       Update Calendar
      </button>
      <button type="button" class="btn btn-secondary cancelCal" (click)="cancelUpdateCalendar()">
        Cancel
      </button>
    </div>
  </section>
 </div>

 <!--Calendar and units section -->
 <div class="row units-section" *ngIf="stsProductsJoinedList?.length >0">
  <div class="calendar-overlay" *ngIf="updateFreqFlag"></div>
  <section class="scheduler-section ship-immediate" *ngFor="let month of monthsList; let m = index">
    <div class="row align-items-center mb-4">
      <div class="col-md-3">
        <img class="mr-1" src="../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" /><span class="cal-month">{{month?.monthyear}}</span>
      </div>
      <div class="col-md-4 d-flex align-items-center">
      </div>
      <div class="col-md-5 d-flex align-items-center justify-content-end shipimmediate-total">
        <span class="mr-2">Total Units</span>
        <!--below units & doses have to be calculated for sum of both the products-->
        <span id="{{'stsMonthUnits-'+m}}">{{month?.totalUnits}}</span><span class="ml-1 mr-2">Units</span>
        <span class="mr-2">|</span>
        <span class="mr-2" id="{{'stsMonthDoses-'+m}}">{{month?.totalDoses}}</span><span class="ml-1 mr-4">Doses</span>
        <span (click)="month.showUnits = !month.showUnits" class="ml-3">
          <img src="../../../../assets/icons/{{baseSiteId}}/plus-green.png" *ngIf="month?.showUnits == false" class="plusminus-icon"/>
          <img src="../../../../assets/icons/{{baseSiteId}}/minus-green.png" *ngIf="month?.showUnits == true" class="plusminus-icon"/>
        </span>
      </div>
    </div>
    <div *ngIf="month?.showUnits" class="showunits-parent">
      
      <div class="show-units-yes"><div class="material-title"></div>
      <ng-container *ngFor="let stsData1 of stsReservationList; let n1 = index">
        <ng-container *ngFor="let materialData of stsData1?.materialSchedule; let o1 = index">
          <ng-container *ngIf="materialData?.stsMonthYear == month?.monthyear">
            <ng-container *ngFor="let week of materialData?.weekList;let w1=index">
              <ng-container *ngIf="n1==0">
                <div class="week-card">
                  <span class="weekLabel">Week</span>
                  <!-- <br/> -->
                  <span class="weekNumber">{{ transformWeek(week?.startMonday)}}</span>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <ng-container *ngFor="let stsData2 of stsProductsJoinedList;let n2=index">
      <div class="material-items"><div class="material-title">Requested</div>
      <ng-container *ngFor="let materialData2 of stsData2?.materialSchedule; let o2 = index">
        <ng-container *ngIf="materialData2?.stsMonthYear == month?.monthyear">
          <ng-container *ngFor="let week2 of materialData2?.weekList;let w2=index">
            <div class="unit-card">
              <!-- <span [hidden]="true" 
              id="{{'exceedsPopover-'+stsData2?.materialNum+'-'+m+'-'+w2}}"
              (click)="togglePopover(exceedsPopover1)"></span> -->
              <span [hidden]="true" 
              id="{{'exceedsPopoverOpen-'+stsData2?.materialNum+'-'+m+'-'+w2}}"
              (click)="openPopover(exceedsPopover1)"></span>
              <span [hidden]="true" 
              id="{{'exceedsPopoverClose-'+stsData2?.materialNum+'-'+m+'-'+w2}}"
              (click)="closePopover(exceedsPopover1)"></span>
              <span>Units</span>
              <input type="number" class="prod-quantity text-center" 
              (keypress)="numberCheck($event)"
              (blur)="checkBlank($event)"
              id="{{'stsinput-'+stsData2?.materialNum+'-'+m+'-'+w2}}" 
              [(ngModel)]="week2.finalQty" max="9999" min="0"
              [disabled]="!week2?.weekEnable||isCalendarViewOnly"
              [ngbPopover]="exceedsTooltip"
              triggers="manual" #exceedsPopover1="ngbPopover" 
              placement="top"
              popoverClass="popover-links stsExceedsPopover"
              [autoClose]="false"
              (keyup)="performQuantityUpdation($event,stsData2?.materialNum, week2, w2,m)"
              [ngClass]="{'unit-success':week2.finalQty > 0 && !week2.showpopover,
                          'unit-error': week2.finalQty > 0 && week2.showpopover}"/>

              <div class="sts-unit-doses" id="{{ 'stsdoses-'+stsData2?.materialNum+'-'+week2?.startMonday}}" 
              *ngIf="week2.finalQty >0"
              [ngClass]="{'doses-error':week2.finalQty > 0 && week2.showpopover}">{{week2.finalQty * stsData2?.quantityPerUnit}} Doses</div>
            </div>
            <ng-template #exceedsTooltip>
              <div class="exceedsContent">
                 <div class="imgBlock">
                    <img src="../../../assets/icons/{{baseSiteId}}/warning_red_new.png" class="positive-green-icon"
                    alt="success">
                 </div>
                <div class="contentBlock">
                 <span class="exceedsMsg">
                  Exceeds limit <br/>
                  Please reduce your<br/>
                  units/doses.
                </span>
                </div>
                  
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>
     </div>
     <ng-container *ngIf="n2 + 1 === stsProductsJoinedList?.length">
      <div class="weeks-items"><div class="material-title"></div>
        <ng-container *ngFor="let materialData2 of stsData2?.materialSchedule; let o2 = index">
          <ng-container *ngIf="materialData2?.stsMonthYear == month?.monthyear">
            <ng-container *ngFor="let week2 of materialData2?.weekList;let w2=index">
              <div class="empty-card"></div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
     </ng-container>
     
    </ng-container>
    </div>
  </section>
</div>
</div>